
































import { defineComponent } from '@vue/composition-api';
import type { PropType } from 'vue';

export default defineComponent({
  name: 'TechnicalDetail',
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Array as PropType<String[]>,
      default: () => {
        return [];
      },
    },
  },
  setup() {
    const isPlainObject = (input) => {
      return input && !Array.isArray(input) && typeof input === 'object';
    };
    return {
      isPlainObject,
    };
  },
});
